import {UyapRequest} from "./UyapRequest";
import app from "@/main";
import {ISorguSonuc} from "./CommonInterfaces";
import {DosyaBorcluEgmMahrumiyetCevap} from "@/plugins/uyap-plugin/uyap/DosyaBorcluEgmMahrumiyet";
import {indexOf} from "lodash";

export interface DosyaBorcluEgmTalep {
    dosyaId: string | number,
    kisiKurumId: number,
    sorguBakiye: number | string,
    pageIndex: 0
}

export interface DosyaBorcluEgmCevap extends ISorguSonuc<IDosyaBorcluEgmSonuc>{
}

export interface IDosyaBorcluEgmSonuc {
    aracBilgileri: AracBilgileri,
    borcluBilgileri: BorcluBilgileri,
    aracSayisi: number,
}

export interface AracBilgileri {
    hataMesaj: string,
    hatakod: number,
    kurumAdi: string,
    kurumTipi: number,
    aracList: Array<IArac>,
    sonuc?: string,
}

export interface IArac {
    cins: string,
    isMock: boolean,
    marka: string,
    model: string,
    plaka: string,
    plakaSifreli: string,
    renk: string,
    ticariAd: string,
    selected: boolean,
    mahrumiyet: DosyaBorcluEgmMahrumiyetCevap|null,
    hacizSerhi: number
}

export interface BorcluBilgileri {
    kisiKurumId: number,
    kisiTumDVO: KisiTumDVO,
    turu: number
}

export interface KisiTumDVO {
    adi: string,
    aktifMernisAdresiSorgusu: boolean,
    anaAdi: string,
    babaAdi: string,
    dogumTarihiStr: string,
    hasOlumKaydi: boolean,
    isAvukat: boolean,
    isHakimSavci: boolean,
    isNoter: boolean,
    isTarafUyari: boolean,
    mernisDegisiklikNedeni: string,
    mernisDegisiklikVarmi: boolean,
    olumKaydi: boolean,
    sorguTuru: number,
    soyadi: string,
    tcKimlikNo: string,
}

export default class DosyaBorcluEgm extends UyapRequest<DosyaBorcluEgmTalep, DosyaBorcluEgmCevap> {
    getMethod(): 'GET' | 'POST' {
        return 'POST';
    }

    getSpinnerMessage(){
        return "Dosya borçlu EGM bilgileri sorgulanıyor...";
    }


    cache() {
        return {
            active: true,
            ttl: (60 * 24), //* 1 gun
            key: "Borclu_EGM_" + app.$uyapHelper.hash(this.talepData)
        };
    }

    getMockResponse(): any {
        return {"borcluBilgileri":{"kisiTumDVO":{"olumKaydi":false,"isAvukat":false,"isGecerlilikAktifAvukat":false,"isNoter":false,"isTarafUyari":false,"isHakimSavci":false,"mernisDegisiklikVarmi":false,"mernisDegisiklikNedeni":"","sorguTuru":0,"tcKimlikNo":"2********06","adi":"Çİ****","soyadi":"KÖ************","babaAdi":"S****","anaAdi":"Z******","dogumTarihiStr":"1955","aktifMernisAdresiSorgusu":true,"hasOlumKaydi":false},"kisiKurumId":230642635,"turu":0},"sorgulayanBilgileri":"Av.MEHMET ALİ DURMUŞ","portalTuru":2,"dosyaOzetDVO":{"birimDVO":{"birimAdi":"İstanbul 7. İcra Dairesi","birimId":"1004796","orgKodu":"1.04.070.000.6007","duzey1":"1","duzey2":"04","duzey3":"070","duzey4":"000","duzey5":"6007","birimTuru1":"11","birimTuru2":"1101","birimTuru3":"1199","evraginBirimDVODaGonderilecegiBirimBilgisi":0,"yeniBirimEkle":true,"orgKoduDegisti":false,"isTumunuKopyala":false,"eskiAd":"","eskiOrgKod":"","taranmamisKaydetme":"","testMi":0},"rolIdList":[],"isBirimKapali":false,"dosyaTurKod":35,"dosyaTurAd":"İcra Dosyası","dosyaNo":"2024/19296","dosyaNoYil":2024,"dosyaSira":19296,"dosyaId":"R7vNf9ktNsi+LmxXMn0CFOZ5V2vG9FQKpafbe+JMW6HbIV3kAwtyTcsuuhJKruiO","dosyaAcilisTarihi":"25/07/2024 09:26","genelDosyaDurumu":"Açık","genelDosyaDurumuAsInteger":0,"taraflar":"KMO ANADOLU OTOYOL İŞLETMESİ ANONİM ŞİRKETİ","vekilId":1275143,"vekilMi":false,"vekilHazineAvukatiMi":false,"adet":0},"sorguTarihi":"28/02/2025 15:54","sorguSonucDVO":{"aracBilgileri":{"aracList":[{"plaka":"34****66","marka":"KIA","model":"2024","ticariAd":"XCEED","renk":"GRİ (Yuka)","cins":"OTOMOBİL","plakaSifreli":"5PDo6eZgycqdyB8d5qhjZg\u003d\u003d","isMock":false}],"aracSayisi":1,"isMock":false},"borcluBilgileri":{"kisiTumDVO":{"olumKaydi":false,"isAvukat":false,"isGecerlilikAktifAvukat":false,"isNoter":false,"isTarafUyari":false,"isHakimSavci":false,"mernisDegisiklikVarmi":false,"mernisDegisiklikNedeni":"","sorguTuru":0,"tcKimlikNo":"2********06","adi":"Çİ****","soyadi":"KÖ************","babaAdi":"S****","anaAdi":"Z******","dogumTarihiStr":"1955","aktifMernisAdresiSorgusu":true,"hasOlumKaydi":false},"kisiKurumId":230642635,"turu":0}},"sorgulamaTuru":"EGM Sorgu","sorguSonucu":false,"hasError":false,"hasData":false,"isMock":false}
    }


    getUrl(): string {
        return this.ImzaClientAddr + 'borclu_bilgileri_goruntule_egm_brd.ajx';
    }

    async parse(data: any): Promise<DosyaBorcluEgmCevap> {
        if (typeof data.sorguSonucDVO != "undefined"){
            data.sorguSonucu = true;
            if(typeof data.sorguSonucDVO.data != "undefined"){
                data.sorguSonucu.aracBilgileri.aracList = [];
                data.sorguSonucDVO.aracBilgileri.aracSayisi = 0;
                data.message = "Kişiye ait araç kaydı yok";
            }
            if(typeof data.sorguSonucDVO.aracBilgileri.aracList != "undefined"){
                data.message = "Kişiye ait araç kaydı " + (data.sorguSonucDVO.aracBilgileri.aracSayisi > 0 ? 'var' : 'yok');
                data.sorguSonucDVO.aracBilgileri.aracList.forEach((arac: IArac) => {
                    arac.selected = true;
                    arac.mahrumiyet = null;
                    arac.hacizSerhi = 0;
                });
            }
            return data;
        }
        console.log("EGM PARSER Return ERROR message",data.message);
        throw new Error(data.message);
    }
}

